import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  en: {
    // nav
    dashboard: "Dashboard", signals: "Signals", smc_vision: "SMC Vision", mega_zones: "Mega Zones",
    markets: "Markets", community: "Community", academy: "Academy", journal: "Journal",
    tools: "Tools", news: "News", calendar: "Calendar", admin: "Admin", profile: "Profile",
    settings: "Settings", notifications: "Notifications", logout: "Logout", trading: "Trading",
    education: "Education", intelligence: "Intelligence",
    // auth
    welcome_back: "Welcome back", sign_in: "Sign in", email: "Email", password: "Password",
    login_title: "The Money Club", login_sub: "MT5 Trading Bot & Panel",
    change_password: "Change password", new_password: "New password", current_password: "Current password",
    first_login_msg: "Please set a new password to continue.",
    // access
    access_expired: "Your TMC access has expired", access_enter_code: "Enter your current access code",
    access_code: "Access code", redeem: "Redeem", access_granted: "Access granted",
    // dashboard
    market_overview: "Market Overview", daily_scenario: "Daily SMC Scenario", latest_signals: "Latest Signals",
    upcoming_sessions: "Upcoming Sessions", academy_progress: "Academy Progress", announcements: "Announcements",
    login_streak: "day streak", completed: "completed", view_all: "View all",
    // generic
    loading: "Loading...", no_data: "No data available", error_generic: "Something went wrong",
    save: "Save", cancel: "Cancel", create: "Create", delete: "Delete", edit: "Edit", search: "Search",
    submit: "Submit", generate: "Generate", coming_soon: "Coming Soon", active: "Active", status: "Status",
    entry: "Entry", direction: "Direction", instrument: "Instrument", risk: "Risk", analysis: "Analysis",
    demo_mode: "DEMO DATA", high: "High", low: "Low", price: "Price", change: "Change",
    // smc
    timeframes: "Timeframes", analyze: "Analyze", bias: "Bias", confluence: "Confluence Score",
    bullish_scenario: "Bullish Scenario", bearish_scenario: "Bearish Scenario", liquidity: "Liquidity",
    market_structure: "Market Structure", order_blocks: "Order Blocks", max_tf: "Select up to 4 timeframes",
    // journal
    add_trade: "Add Trade", win_rate: "Win Rate", total_pnl: "Net P/L", profit_factor: "Profit Factor",
    total_trades: "Total Trades", ai_review: "AI Weekly Review", avg_r: "Avg R",
    // academy
    modules: "Modules", lessons: "Lessons", quiz: "Quiz", exam: "Final Exam", certificate: "Certificate",
    glossary: "Glossary", start: "Start", complete: "Complete", passed: "Passed", failed: "Not passed",
    download_certificate: "Download Certificate",
    // tools
    position_size: "Position Size", risk_calc: "Risk Calculator", rr_calc: "R:R Calculator",
    pip_calc: "Pip Calculator", compounding: "Compounding", calculate: "Calculate",
    // community
    message_placeholder: "Type a message...", send: "Send", members: "Members", channels: "Channels",
  },
  pl: {
    dashboard: "Pulpit", signals: "Sygnały", smc_vision: "SMC Vision", mega_zones: "Mega Strefy",
    markets: "Rynki", community: "Społeczność", academy: "Akademia", journal: "Dziennik",
    tools: "Narzędzia", news: "Wiadomości", calendar: "Kalendarz", admin: "Admin", profile: "Profil",
    settings: "Ustawienia", notifications: "Powiadomienia", logout: "Wyloguj", trading: "Trading",
    education: "Edukacja", intelligence: "Analityka",
    welcome_back: "Witaj ponownie", sign_in: "Zaloguj się", email: "E-mail", password: "Hasło",
    login_title: "The Money Club", login_sub: "Bot tradingowy MT5 i panel",
    change_password: "Zmień hasło", new_password: "Nowe hasło", current_password: "Obecne hasło",
    first_login_msg: "Ustaw nowe hasło, aby kontynuować.",
    access_expired: "Twój dostęp do TMC wygasł", access_enter_code: "Wpisz aktualny kod dostępu",
    access_code: "Kod dostępu", redeem: "Aktywuj", access_granted: "Dostęp przyznany",
    market_overview: "Przegląd Rynku", daily_scenario: "Dzienny Scenariusz SMC", latest_signals: "Najnowsze Sygnały",
    upcoming_sessions: "Najbliższe Sesje", academy_progress: "Postęp w Akademii", announcements: "Ogłoszenia",
    login_streak: "dni z rzędu", completed: "ukończone", view_all: "Zobacz wszystko",
    loading: "Ładowanie...", no_data: "Brak danych", error_generic: "Coś poszło nie tak",
    save: "Zapisz", cancel: "Anuluj", create: "Utwórz", delete: "Usuń", edit: "Edytuj", search: "Szukaj",
    submit: "Wyślij", generate: "Generuj", coming_soon: "Wkrótce", active: "Aktywny", status: "Status",
    entry: "Wejście", direction: "Kierunek", instrument: "Instrument", risk: "Ryzyko", analysis: "Analiza",
    demo_mode: "DANE DEMO", high: "Max", low: "Min", price: "Cena", change: "Zmiana",
    timeframes: "Interwały", analyze: "Analizuj", bias: "Nastawienie", confluence: "Wynik Konfluencji",
    bullish_scenario: "Scenariusz Wzrostowy", bearish_scenario: "Scenariusz Spadkowy", liquidity: "Płynność",
    market_structure: "Struktura Rynku", order_blocks: "Order Blocks", max_tf: "Wybierz maks. 4 interwały",
    add_trade: "Dodaj Transakcję", win_rate: "Skuteczność", total_pnl: "Wynik Netto", profit_factor: "Profit Factor",
    total_trades: "Transakcje", ai_review: "Tygodniowa Analiza AI", avg_r: "Śr. R",
    modules: "Moduły", lessons: "Lekcje", quiz: "Quiz", exam: "Egzamin Końcowy", certificate: "Certyfikat",
    glossary: "Słownik", start: "Rozpocznij", complete: "Ukończ", passed: "Zdany", failed: "Niezdany",
    download_certificate: "Pobierz Certyfikat",
    position_size: "Wielkość Pozycji", risk_calc: "Kalkulator Ryzyka", rr_calc: "Kalkulator R:R",
    pip_calc: "Kalkulator Pipsów", compounding: "Procent Składany", calculate: "Oblicz",
    message_placeholder: "Napisz wiadomość...", send: "Wyślij", members: "Członkowie", channels: "Kanały",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("tmc_lang") || "pl");
  const setLang = useCallback((l) => { setLangState(l); localStorage.setItem("tmc_lang", l); }, []);
  const t = useCallback((key) => (dict[lang] && dict[lang][key]) || (dict.en[key]) || key, [lang]);
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
